import React, { useContext } from 'react';
import { IntlProviderContext } from './IntlProvider';
import parseMessage from './parseMessage';

export interface MessagesValues {
  [key: string]: string | number | null;
}

export interface FormattedMessageProps {
  id: string;
  values?: MessagesValues;
}

const FormattedMessage = ({ id, values }: FormattedMessageProps): React.JSX.Element => {
  const { messages } = useContext(IntlProviderContext);
  let message = messages[id] || id;

  if (values) {
    message = parseMessage(message, values);
  }

  return <span>{message}</span>;
};

export default FormattedMessage;
